// 장례식장 상세 재방문 실험(#318) 리드 제출 시 #홈 질문 슬랙으로 보낼 메시지.
// buildParlorUsageLeadMessage(무빈소·상조 니즈 전용, 2026-09 제거)와 문의 성격이 달라 분리했다 - 이쪽은
// "재방문 유저에게 비용 안내 모달을 띄웠고, 조문객수를 선택 후 번호를 남겼다"는 문맥.

export function buildParlorRevisitLeadMessage({
  parlorName,
  region,
  mournerCount,
}: {
  parlorName: string;
  /** "경기 안성시"처럼 사람이 읽는 시도+시군구 지역명 */
  region?: string;
  /** 1단계에서 선택한 예상 조문객수 옵션 */
  mournerCount: string;
}): string {
  const regionLine = region ? `지역 : *${region}*\n` : "";
  // v2: 헤더·전화번호·🚨는 BE가 부착 (postLeadV2). 여기선 사람용 스토리만.
  return `질문 내용 : *장례식장 비용 문의*\n\n장례식장 상세 페이지 *재방문(2회 이상)* 시 노출된 비용 안내 모달을 통해 접수된 리드입니다.\n\n장례식장 : *${parlorName}*\n${regionLine}예상 조문객수 : *${mournerCount}*\n-----\n⚠️ 장례식장 오인지 가능성이 높은 고객입니다.\n고이가 아닌 '${parlorName}'에서 직접 비용 안내가 가능한지 궁금한 케이스일 가능성이 높습니다.\n상황 확인 후, 추가적인 세일즈 부탁드립니다.`;
}
